
/********* REFRESH *********/

export const REFRESH_APP_SETTINGS = 'REFRESH_APP_SETTINGS'
export const REFRESH_APP_SETTINGS_OK = 'REFRESH_APP_SETTINGS_OK'
export const REFRESH_APP_SETTINGS_ERR = 'REFRESH_APP_SETTINGS_ERR'
export const DO_REFRESH_APP_ASETTINGS_CLEANUP = 'DO_REFRESH_APP_ASETTINGS_CLEANUP'